import {Box, styled, Button, CollectionsOutlinedIcon, VisibilityIcon, DeleteOutlineIcon, BrokenImageOutlinedIcon, Alert, ImageList} from '../../../ui-library';

export const ContainerBox = styled(Box)`
    display: flex;
    flex-direction: column;
`;

export const ContainerBoxUploadBtn = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const UploadBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    font-size: 16px;
    line-height: 26px;
`;

export const NumOfImagesIcon = styled(CollectionsOutlinedIcon)`
    color : ${({ theme }) => theme.palette.grey['600']};
    font-size: 19.21px;
    margin-left: 14px;
    margin-right: 8px;
`;

export const ErrorBox = styled(Box)`
    display: flex;
    position: absolute;
    border-radius: 10px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6));
    width: 88px;
    height: 88px;;
`;


export const HoverBox = styled(Box)`
    display: flex;
    position: absolute;
    border-radius: 10px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
    width: 100%;
    min-height: 100%;
    z-index: var(--layer-1st);
`;

export const DisableBox = styled(Box)`
    display: flex;
    position: absolute;
    border-radius: 10px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
    width: 100%;
    min-height: 100%;
    z-index: var(--layer-1st);
`;

export const DisableBoxAutoClasses = styled(Box)`
    display: flex;
    position: absolute;
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100%;
    z-index: var(--layer-1st);
`;

export const IconsContainer = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 100%;
`;

export const DeleteContainer = styled(Box)`
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
`;

export const DeleteStyledIcon = styled(DeleteOutlineIcon)`
    color: #FFFFFF;
    position: absolute;
    right: 12px;
    top: 12px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    z-index: var(--layer-1st);
`;

export const Eye = styled(VisibilityIcon)`
    color: #FFFFFF;
    cursor: pointer;
    z-index: var(--layer-1st);
`;

export const DeleteImage = styled(DeleteOutlineIcon)`
    color: #FFFFFF;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    z-index: var(--layer-1st);
`;


export const BrokenImageContainer = styled(Box)`
    background:  ${({ theme }) => theme.palette.grey['300']};
    display: flex;
    position: absolute;
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    width: 88px;
    height: 88px;
`;

export const BrokImageIcon = styled(BrokenImageOutlinedIcon)`
    width: 34px;
    height: 34px;
    color:  ${({ theme }) => theme.palette.grey['400']};;
`;

export const AlertOutlined = styled(Alert)`
    margin-top: 30px;
`;

export const AlertFull = styled(Alert)`
    margin-top: 30px;
    background-color: #FDEDF0;
`;

export const ImageListNewCLass = styled(ImageList)`
    width: 100%;
    overflow-x: hidden;
    max-height: 190px;
`;

